export default "__VITE_ASSET__LgVOx68d__"